import { faBuilding } from "@fortawesome/pro-light-svg-icons";
import { useMemo } from "react";
import { InfrastructureEquipmentListInfraTypeEnum } from "../../../../apiClient/generated";
import { CustomSwitch } from "../../../../ui/CustomSwitch";
import { useMapFilters } from "../../hooks/mapDataAndFilters";
import { ToolBarDropdown } from "../../ui/MapControlsV2";
import {
    MenuCategory,
    MenuCheckboxItem,
    PipelinePickerMenu,
} from "../../ui/Menu";

interface InfrastructureControlProps {
    className?: string;
}

export const InfrastructureControl = (props: InfrastructureControlProps) => {
    const { filterState, updateMapFilterState } = useMapFilters("mainMap");
    const infrastructureFilters = useMemo(
        () => filterState.infrastructure,
        [filterState.infrastructure],
    );

    return (
        <ToolBarDropdown
            enabled={true}
            icon={faBuilding}
            label="Assets"
            className={props.className}
        >
            <div className="text-sm min-w-44 px-1">
                <MenuCategory>Filter Assets</MenuCategory>
                <div className="mt-1 flex items-center gap-2">
                    <CustomSwitch
                        size="xs"
                        checked={infrastructureFilters.showInfrastructure}
                        onChange={() => {
                            updateMapFilterState((s) => {
                                s.infrastructure.showInfrastructure =
                                    !s.infrastructure.showInfrastructure;
                            });
                        }}
                    />
                    <span className="flex-grow">Show Infrastructure</span>
                </div>
                <hr className="mt-2 mb-1 h-[1px] border-0 mx-1 bg-ae-slate-200" />
                <MenuCheckboxItem
                    label="Sites"
                    options={[
                        {
                            id: InfrastructureEquipmentListInfraTypeEnum.Site,
                            label: "Sites",
                        },
                        {
                            id: InfrastructureEquipmentListInfraTypeEnum.Equipment,
                            label: "Equipments & Groups",
                        },
                    ]}
                    selected={infrastructureFilters.infraTypeFilter}
                    setSelected={(v) =>
                        updateMapFilterState((s) => {
                            if (v === "all") {
                                s.infrastructure.infraTypeFilter = [
                                    InfrastructureEquipmentListInfraTypeEnum.Site,
                                    InfrastructureEquipmentListInfraTypeEnum.Equipment,
                                ];
                            } else if (Array.isArray(v)) {
                                s.infrastructure.infraTypeFilter =
                                    v as InfrastructureEquipmentListInfraTypeEnum[];
                            }
                        })
                    }
                />
                <PipelinePickerMenu
                    products={infrastructureFilters.pipelineProduct}
                    setProducts={(v) => {
                        updateMapFilterState((s) => {
                            s.infrastructure.pipelineProduct = v;
                        });
                    }}
                    types={infrastructureFilters.pipelineType}
                    setTypes={(v) => {
                        updateMapFilterState((s) => {
                            s.infrastructure.pipelineType = v;
                        });
                    }}
                />
            </div>
        </ToolBarDropdown>
    );
};
